import React from 'react'
import PropTypes from 'prop-types'

import Image from 'suitTheme/Image'
import StatusBadge from 'suitTheme/StatusBadge'

import useImage from 'agency/hooks/useImage'

const Thumbnail = (props) => {
  const {
    creating,
    callbacks: { selectImage },
    image,
    viewMode,
  } = props

  const imagePayload = useImage(image)
  const {
    image: { id_code, thumb_url },
    resolution: { label, warn },
  } = imagePayload

  return (
    <Image
      boxProps={{
        onClick: creating ? null : () => selectImage(image),
        alignItems: 'center',
        position: 'relative',
      }}
      borderRadius={5}
      height={viewMode === 'large' ? 200 : 110}
      url={thumb_url}
      width="100%"
      style={{ cursor: 'pointer' }}
    >
      {warn && (
        <StatusBadge
          boxProps={{
            position: 'absolute',
            top: 'medium',
            left: 'medium',
            width: 'auto',
          }}
          color={label === 'Low' ? 'red' : 'orange'}
          text={label}
        />
      )}

      {id_code && (
        <StatusBadge
          boxProps={{
            position: 'absolute',
            top: 'medium',
            right: 'medium',
            width: 'auto',
          }}
          color="rgba(0, 0, 0, 0.8)"
          text={id_code}
        />
      )}
    </Image>
  )
}

Thumbnail.propTypes = {
  creating: PropTypes.bool,
  callbacks: PropTypes.shape({
    selectImage: PropTypes.func.isRequired,
  }).isRequired,
  image: PropTypes.object.isRequired,
  viewMode: PropTypes.oneOf(['small', 'large']).isRequired,
}

export default Thumbnail
